import WebFont from 'webfontloader'
import some from 'lodash/some'

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async connect() {
    const controller = this
    const webFonts = await this.fetchWebFonts()

    $(this.element).find('[style*="font-family"]').each(function() {
      const fontFamily = controller.getFirstFontFamily($(this).css('font-family'))

      if(some(webFonts, { family: fontFamily })) {
        WebFont.load({ google: { families: [`${fontFamily}:regular,italic,700,700italic:latin-ext`] } })
      }
    })
  }

  fetchWebFonts() {
    const webfontsAddress = new URL('/webfonts/simple', window.location.href).href
    return $.getJSON(webfontsAddress).then(data => data.items)
  }

  getFirstFontFamily(declaration) {
    return declaration.split(',')[0].replace(/['"]+/g, '').trim()
  }
}
